export class SaveCloudResourceSecurityPropertiesRequest {
    'securityProperties';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "securityProperties",
            "baseName": "securityProperties",
            "type": "CloudResourceSecurityProperties",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaveCloudResourceSecurityPropertiesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
